import {
  GET_RESEARCHED_TEL_HAS_DEPARTMENTS_REQUEST,
  GET_RESEARCHED_TEL_HAS_DEPARTMENTS_SUCCESS,
  GET_RESEARCHED_TEL_HAS_DEPARTMENTS_FAILURE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';

const initialState = {
  // API取得前・取得失敗時でも undefined にならないよう空配列で初期化する
  departmentKeys: [],
  isLoadingDepartments: false,
  errorMessage: '',
  message: '',
  error: null,
};

export default (state = initialState, action) => {
  state = {
    ...state,
    errorMessage: '',
  }

  switch (action.type) {
    case GET_RESEARCHED_TEL_HAS_DEPARTMENTS_REQUEST:
      return {
        ...state,
        isLoadingDepartments: true,
      }
    case GET_RESEARCHED_TEL_HAS_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        isLoadingDepartments: false,
        departmentKeys: Object.values(action.payload.data),
      }
    case GET_RESEARCHED_TEL_HAS_DEPARTMENTS_FAILURE:
      return {
        ...state,
        isLoadingDepartments: false,
        errorMessage: action.payload.error.data.message ? action.payload.error.data.message : errMessages.ERR_BAD_FORMAT,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/corporationTelResearch.js